import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  Stack,
} from '@mui/material'
import React, { useState } from 'react'
import { useMutation } from 'react-query'
import { AxiosResponse } from 'axios'
import PyAPI from '../../../APIs/Python/APIs/PyAPI'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useUserContext } from '../../../Contexts/UserConfig'
import { listFromKV } from '../../../Functions/ListItemGenerator'
import { useGetCodeSet } from '../../../APIs/Hooks/CodeSetHooks'
import { Box } from '@mui/system'

function ModalValidateVanRun() {
  const { setError, setMessage } = useMessagePopupContext()
  const { whoAmI } = useUserContext()
  const [vanID, setVanID] = useState<string>('')
  const [openValidate, setOpenValidate] = useState(false)
  const mutateVanRun = useMutation<any, AxiosResponse>({
    mutationFn: () => PyAPI.get(whoAmI!, '/vanrun/validate/' + vanID),
    onError: (err) => setError(err),
    onSuccess: (data) => {
      setMessage({
        subject: 'Result',
        message: data?.message ?? data,
        severity: data?.severity ?? 'success',
      })
    },
  })

  const vanQuery = useGetCodeSet('VanNameID')
  const vanNames = listFromKV(
    vanQuery.data ?? [],
    vanQuery.isLoading,
    vanID || '',
  )

  return (
    <>
      <Button
        variant={'outlined'}
        size={'small'}
        onClick={() => setOpenValidate(true)}
      >
        Validate Van Run
      </Button>
      <Dialog open={openValidate}>
        <DialogTitle>{'Please select a van'}</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <FormControl
              fullWidth
              sx={{ minWidth: 200 }}
            >
              <InputLabel>Van Name</InputLabel>
              <Select
                label="Van Name"
                name="vanName"
                value={vanID}
                onChange={(e) => setVanID(e.target.value)}
              >
                {vanNames}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Stack
            gap={1}
            direction={'row'}
          >
            <Button
              onClick={() => {
                setOpenValidate(false)
                setVanID('')
              }}
              color="error"
              variant={'outlined'}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                setOpenValidate(false)
                mutateVanRun.mutate()
                setVanID('')
              }}
              variant={'outlined'}
              disabled={!vanID}
            >
              Validate
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ModalValidateVanRun
